export function typographier(texte) {
  if (typeof texte !== "string") return texte;

  return (
    texte
      // Espace fine insécable avant . ! ? , ; :
      .replace(/([!?:;])/g, "\u202F$1")
      // Points de suspension : "..." devient fine insécable + …
      .replace(/\.{3}/g, "\u202F…")
      // Guillemets français : remplace "texte" par « texte »
      .replace(/"([^"]*?)"/g, "«\u202F$1\u202F»")
  );
}

export function MyTypo(texte) {
  return typographier(texte);
}
